import { render, staticRenderFns } from "./AllergyPatientInfoBox.vue?vue&type=template&id=3be0bdcc&scoped=true"
import script from "./AllergyPatientInfoBox.vue?vue&type=script&lang=js"
export * from "./AllergyPatientInfoBox.vue?vue&type=script&lang=js"
import style0 from "./AllergyPatientInfoBox.vue?vue&type=style&index=0&id=3be0bdcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0bdcc",
  null
  
)

export default component.exports